import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, alpha } from '@material-ui/core';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    backgroundColor: `${alpha(primary.white, 0.4)}`,
    boxShadow: `0px 2px 8px 0px ${alpha(primary.black, 0.17)}`,
    boxSizing: 'border-box',
    borderRadius: 8,
    display: 'grid',
    position: 'absolute',
    top: 220,
    left: 22,
    zIndex: 1,
    padding: spacing(2.5),
    width: 'fit-content',
    minWidth: 120,
    height: 106,
  },
  scoreLabel: {
    color: primary.indigo,
    textAlign: 'center',
  },
  scoreValue: {
    fontSize: 66,
    fontFamily: 'ProximaNova-Bold',
    lineHeight: '66px',
    color: primary.indigo,
    textAlign: 'center',
  },
}));

const ReportScore = ({ translations, score }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.scoreLabel}>
        {translations.score}
      </Typography>
      <Typography variant="body1" className={classes.scoreValue}>
        {score}
      </Typography>
    </div>
  );
};

ReportScore.propTypes = {
  translations: PropTypes.object.isRequired,
  score: PropTypes.number.isRequired,
};

export default ReportScore;
